import { motion, useReducedMotion } from "framer-motion";
import { HACKATHON } from "@/data/agenticHackathon";
import { springTransition } from "@/lib/motionVariants";

/**
 * Free badge — calendar-style orange header + white body (matches date tile).
 */
export default function HackathonFreeCapsule({ className = "" }) {
    const reduceMotion = useReducedMotion();

    return (
        <motion.div
            data-testid="hackathon-free-badge"
            initial={reduceMotion ? false : { opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springTransition}
            className={`inline-flex overflow-hidden rounded-[10px] sm:rounded-xl ring-1 ring-black/10 shadow-[0_8px_24px_-8px_rgba(0,0,0,0.35)] ${className}`}
        >
            <span className="inline-flex items-center shrink-0 bg-[#E54D2E] px-3 py-2 sm:px-3.5 sm:py-2.5 border-r border-white/20">
                <span className="font-display text-[10px] sm:text-xs font-semibold uppercase tracking-[0.14em] text-white whitespace-nowrap">
                    {HACKATHON.freeLabel}
                </span>
            </span>
            <span className="inline-flex items-center bg-white px-3 py-2 sm:px-4 sm:py-2.5">
                <span className="font-display text-[10px] sm:text-xs font-semibold uppercase tracking-[0.14em] text-zinc-900 whitespace-nowrap">
                    to attend
                </span>
            </span>
        </motion.div>
    );
}
